import React from 'react';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const FlareButton = () => {
  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        FXRP is now live on Flare&nbsp;
        <span className="small"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>
        XRP enters DeFi with FXRP — now live on Flare. Lend, borrow, provide liquidity, and soon, stake.
      </Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href="https://api.xrpscan.com/api/v1/campaign/flarebutton"
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >Use XRP in DeFi</Button>
        </OverlayTrigger>
    </span>
  )
}

export default FlareButton;
